import React from "react";
import { observer } from "mobx-react";

import MyBetsViewStore from "@state/stores/my-bets/MyBetsViewStore";
import {
	BetListDisplayAuthUser,
	BetListDisplayHeader,
	NotAuth,
} from "./components";
import CashoutCounter from "@features/my-bets/desktop/common/cashout/CashoutCounter";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { useRootAppStore } from "@hooks";

export default observer(function BetListDisplay(props: {
	myBetsViewStore: MyBetsViewStore;
}) {
	const store = useRootAppStore();

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/BetListDisplay.tsx"}
		>
			<div className="widget widget--bets card--shadowy">
				<CashoutCounter
					store={props.myBetsViewStore.cashoutStore}
					isMini={true}
				/>
				<BetListDisplayHeader myBetsViewStore={props.myBetsViewStore} />
				{store.userAuthStore.user == null ? (
					<NotAuth />
				) : (
					<BetListDisplayAuthUser
						myBetsViewStore={props.myBetsViewStore}
					/>
				)}
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
